import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import './App.css';
import OfflineBanner from 'components/common/OfflineBanner/OfflineBanner';

function App() {
  return (
    <>
      <OfflineBanner />
      <Suspense fallback={<h1>Page is Loading...</h1>}>
        <RouterProvider router={router} />
      </Suspense>
    </>
  );
}

export default App;
